<script setup lang="ts" generic="T extends z.ZodAny">
import type { Config, ConfigItem } from './interface'
// import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import { FormItem, FormMessage } from '@/components/ui/form'
import { PlusIcon, XIcon } from 'lucide-vue-next'
import { FieldArray, FieldContextKey, useField } from 'vee-validate'
import { computed, provide } from 'vue'
import { z } from 'zod'
import AutoFormField from './AutoFormField.vue'
import {
  // beautifyObjectName,
  getBaseType
} from './utils'

const props = defineProps<{
  fieldName: string
  required?: boolean
  config?: Config<T>
  schema?: z.ZodArray<T>
  disabled?: boolean
}>()

const newConfig = computed(() => {
  if (((props.config as ConfigItem)?.inputProps as any)?.newComponent) {
    return {
      ...props.config,
      component: ((props.config as ConfigItem)?.inputProps as any)?.newComponent,
    }
  }
  return props.config
})

function isZodArray(
  item: z.ZodArray<any> | z.ZodDefault<any>,
): item is z.ZodArray<any> {
  return item instanceof z.ZodArray
}

function isZodDefault(
  item: z.ZodArray<any> | z.ZodDefault<any>,
): item is z.ZodDefault<any> {
  return item instanceof z.ZodDefault
}

const itemShape = computed(() => {
  if (!props.schema)
    return

  // Zod v4: item schema is in _def.element (not _def.type which is now the string "array")
  const schema: z.ZodAny = isZodArray(props.schema)
    ? (props.schema._def as any).element
    : isZodDefault(props.schema)
      // @ts-expect-error missing schema
      ? (props.schema._def.innerType._def as any).element
      : null

  return {
    type: getBaseType(schema),
    schema,
  }
})

const fieldContext = useField(props.fieldName)
// @ts-expect-error ignore missing `id`
provide(FieldContextKey, fieldContext)
</script>

<template>
  <div class="pt-8">
    <div class="border-b border-border pb-8">
      <FieldArray v-slot="{ fields, remove, push }"
                  as="section"
                  :name="fieldName">
        <slot v-bind="props">
          <FormItem>

            <!-- <div class="text-base"
             v-if="fields.length === 0">
          {{ schema?.description || beautifyObjectName(fieldName) }}
          <span v-if="required"
                class="text-destructive">*</span>
        </div> -->

            <template v-for="(_field, index) of fields"
                      :key="_field.key">
              <div class="mb-4 p-1 flex items-start justify-between gap-2">
                <AutoFormField :field-name="`${fieldName}[${index}]`"
                               :label="fieldName"
                               :shape="itemShape!"
                               class="w-full"
                               :config="newConfig as ConfigItem" />
                <Button type="button"
                        size="icon"
                        variant="outline"
                        class="mt-8"
                        @click="remove(index)">
                  <XIcon />
                </Button>
              </div>
            </template>

            <Button type="button"
                    variant="outline"
                    class="flex items-center"
                    @click="push(null)">
              <PlusIcon class="mr-2"
                        :size="16" />
              Add New
              <!-- {{ beautifyObjectName(fieldName) || schema?.description }} -->
            </Button>

            <FormMessage />
          </FormItem>
        </slot>
      </FieldArray>
    </div>
  </div>
</template>
